<div class="details-surface row rounded-2">
  <div class="col text-start mt-2 mb-2">
    <span class="details-primary-text fs-lg">{{ category?.title }}</span>
    <i *ngIf="icon" class="{{ icon }}" [ngStyle]="{ transform: 'rotate(' + bearing + 'deg)' }"></i>
  </div>
</div>
<div class="row mt-2">
  <app-details-item
    class="col-6 gy-2 gx-5"
    *ngFor="let content of category?.items"
    [description]="content.description"
    [value]="content.value"
    [unit]="content.unit"
  ></app-details-item>
</div>
